export default "__VITE_ASSET__B9Sdu7w___"